import graphql from 'babel-plugin-relay/macro'
import React, {Suspense} from 'react'
import {useFragment} from 'react-relay'
import taskFooterUserAssigneeMenuQuery, {

} from '../../../__generated__/TaskFooterUserAssigneeMenuQuery.graphql'



import useQueryLoaderNow from '../../../hooks/useQueryLoaderNow'

import {Loader} from '../../../utils/relay/renderLoader'
import TaskFooterUserAssigneeMenu from './OutcomeCardAssignMenu/TaskFooterUserAssigneeMenu'








const TaskFooterUserAssigneeMenuRoot = (props) => {
  const {area, menuProps, task: taskRef, useTaskChild} = props
  const task = useFragment(
    graphql`
      fragment TaskFooterUserAssigneeMenuRoot_task on Task {
        ...TaskFooterUserAssigneeMenu_task
        team {
          id
        }
      }
    `,
    taskRef
  )
  const {team} = task
  const {id: teamId} = team
  useTaskChild('userAssignee')
  const queryRef = useQueryLoaderNow(
    taskFooterUserAssigneeMenuQuery,
    {teamId}
  )
  return (
    React.createElement(Suspense, { fallback: React.createElement(Loader, null ),}
      , queryRef && (
        React.createElement(TaskFooterUserAssigneeMenu, {
          queryRef: queryRef,
          area: area ,
          menuProps: menuProps,
          task: task,}
        )
      )
    )
  )
}

export default TaskFooterUserAssigneeMenuRoot
